import { alpha } from '@mui/material';
const useRightPanelStyles = () => {
    return {
        card: {
            backgroundColor: (theme) => theme.palette.background.default,
            border: (theme) => `1px solid ${alpha(theme.palette.grey[500], 0.24)}`,
            borderRadius: (theme) => theme.spacing(1.75),
            padding: (theme) => theme.spacing(1.5),
            height: '100%',
            // backgroundImage: 'url("/assets/images/card-bg-logo.png")',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'bottom',
            backgroundSize: 'cover'
        },
        cardContentContainer: {
            display: 'flex',
            flexDirection: 'column',
            padding: 0,
            gap: 2,
            height: 'calc(100dvh - 222px)',
            overflowY: 'auto',
            // Hide scrollbar by default, show on hover
            '&::-webkit-scrollbar': {
                width: '6px',
                height: '6px'
            },
            '&::-webkit-scrollbar-track': {
                background: 'transparent'
            },
            '&::-webkit-scrollbar-thumb': {
                background: 'transparent',
                borderRadius: '3px'
            },
            '&:hover::-webkit-scrollbar-thumb': {
                background: 'rgba(0, 0, 0, 0.32)'
            },
            // Firefox scrollbar styling
            scrollbarWidth: 'thin',
            scrollbarColor: 'transparent transparent',
            '&:hover': {
                scrollbarColor: 'rgba(0, 0, 0, 0.32) transparent'
            },
            // Hide scrollbar when dropdowns are open
            '&:has(.MuiAutocomplete-popper, .MuiMenu-root, .MuiPopover-root)': {
                '&::-webkit-scrollbar-thumb': {
                    background: 'transparent !important'
                },
                scrollbarColor: 'transparent transparent !important'
            }
        },
        backgroundGallery: {
            display: 'flex',
            flexDirection: 'column',
            gap: 0.5
        },
        thumbnailContainer: {
            display: 'flex',
            flexWrap: 'wrap',
            gap: 1
        },
        thumbnail: {
            width: 138.67,
            height: 87,
            borderRadius: 2,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat'
        },
        eventPreviewCotnainer: {
            display: 'flex',
            gap: 1,
            width: '100%',
            alignItems: 'center'
        },
        eventPreviewThumbnail: {
            width: 107,
            height: 89,
            borderRadius: 2,
            objectFit: 'cover'
        }
    };
};
export default useRightPanelStyles;
